import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function OdemeFormu() {
  const { siparisNo } = useParams();
  const [siparis, setSiparis] = useState(null);
  const [kalemler, setKalemler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bulunamadi, setBulunamadi] = useState(false);
  const [tamamlandi, setTamamlandi] = useState(false);
  const [yukleniyor, setYukleniyor] = useState(false);
  const [hata, setHata] = useState('');
  const [form, setForm] = useState({ ad_soyad: '', telefon: '', adres: '' });

  useEffect(() => { fetchSiparis(); }, [siparisNo]);

  async function fetchSiparis() {
    // musteriler join'i kaldırıldı — 400 hatasına yol açıyordu
    const { data: s, error } = await supabase
      .from('siparisler')
      .select('id, siparis_no, toplam_tutar, odeme_durumu, odeme_turu, musteri_id, adres, not_, firma_id')
      .eq('siparis_no', siparisNo)
      .single();

    if (error || !s) { setBulunamadi(true); setLoading(false); return; }

    if (s.odeme_durumu === 'odendi') { setTamamlandi(true); setSiparis(s); setLoading(false); return; }

    // Firma adını ayrı çek
    let firmaAd = '';
    if (s.firma_id) {
      const { data: f } = await supabase.from('firmalar').select('ad').eq('id', s.firma_id).single();
      firmaAd = f?.ad || '';
    }

    // Müşteri bilgilerini ayrı çek
    if (s.musteri_id) {
      const { data: m } = await supabase.from('musteriler').select('ad, telefon').eq('id', s.musteri_id).single();
      if (m?.ad) setForm(f => ({ ...f, ad_soyad: m.ad }));
      if (m?.telefon) setForm(f => ({ ...f, telefon: m.telefon }));
    }

    // Kalemleri çek
    const { data: k } = await supabase
      .from('siparis_kalemleri')
      .select('id, miktar, toplam, urun_id')
      .eq('siparis_id', s.id);

    // Ürün adlarını ayrı çek
    const kalemlerDetay = await Promise.all((k || []).map(async kalem => {
      const { data: u } = await supabase.from('urunler').select('ad').eq('id', kalem.urun_id).single();
      return { ...kalem, urun_ad: u?.ad || '' };
    }));

    if (s.adres) setForm(f => ({ ...f, adres: s.adres }));
    setSiparis({ ...s, firma_ad: firmaAd });
    setKalemler(kalemlerDetay);
    setLoading(false);
  }

  async function handleGonder() {
    if (!form.ad_soyad.trim()) { setHata('Ad Soyad gerekli'); return; }
    setHata('');
    setYukleniyor(true);
    try {
      if (siparis.musteri_id) {
        await supabase.from('musteriler').update({ ad: form.ad_soyad, telefon: form.telefon }).eq('id', siparis.musteri_id);
      }
      await supabase.from('siparisler').update({
        adres: form.adres,
        not_: (siparis.not_ ? siparis.not_ + ' | ' : '') + 'Müşteri bilgileri iletildi. Dekont bekleniyor.',
      }).eq('id', siparis.id);
      setTamamlandi(true);
    } catch (err) {
      setHata('Bir hata oluştu: ' + err.message);
    }
    setYukleniyor(false);
  }

  if (loading) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 40, color: '#888' }}>Yükleniyor...</div>
      </div>
    </div>
  );

  if (bulunamadi) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', padding: 40 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>❌</div>
          <h2 style={{ color: '#fff', marginBottom: 8 }}>Sipariş Bulunamadı</h2>
          <p style={{ color: '#888' }}>Bu ödeme linki geçersiz veya süresi dolmuş olabilir.</p>
        </div>
      </div>
    </div>
  );

  const IBAN = 'TR39 0015 7000 0000 0130 3918 60';
  const HESAP_ADI = 'Levent Postalcıoğlu';
  const BANKA = 'Enpara';

  if (tamamlandi) return (
    <div style={sayfaStyle}>
      <div style={kartStyle}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
          <h2 style={{ color: '#4ade80', marginBottom: 8, fontSize: 22 }}>Siparişiniz Alındı!</h2>
          <p style={{ color: '#aaa', fontSize: 14 }}>Sipariş No: <strong style={{ color: '#fff' }}>#{siparisNo}</strong></p>
        </div>
        <div style={{ background: '#1a1d27', borderRadius: 10, padding: 16, marginBottom: 16, textAlign: 'center' }}>
          <p style={{ color: '#aaa', fontSize: 13, marginBottom: 4 }}>Ödenecek Tutar</p>
          <p style={{ color: '#E07B00', fontSize: 28, fontWeight: 900 }}>{(siparis?.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</p>
          <p style={{ color: '#aaa', fontSize: 12, marginTop: 4 }}>
            {siparis?.odeme_turu === 'banka' ? '🏦 Banka Havalesi' : siparis?.odeme_turu === 'kredi_karti' ? '💳 Kredi Kartı' : '💵 Elden/Nakit'}
          </p>
        </div>
        <div style={{ background: '#1a1d27', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <p style={{ color: '#aaa', fontSize: 12, marginBottom: 8, fontWeight: 600 }}>ÖDEME BİLGİLERİ</p>
          <p style={{ color: '#fff', fontSize: 13, marginBottom: 4 }}><span style={{ color: '#aaa' }}>Banka:</span> {BANKA}</p>
          <p style={{ color: '#fff', fontSize: 13, marginBottom: 4 }}><span style={{ color: '#aaa' }}>Hesap Adı:</span> {HESAP_ADI}</p>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8, background: '#0f1117', borderRadius: 8, padding: '10px 12px' }}>
            <span style={{ color: '#fff', fontSize: 14, fontFamily: 'monospace', fontWeight: 700, letterSpacing: 1 }}>{IBAN}</span>
            <button onClick={() => { navigator.clipboard.writeText(IBAN.replace(/\s/g, '')); alert('IBAN kopyalandı!'); }}
              style={{ background: '#E07B00', border: 'none', borderRadius: 6, color: '#fff', cursor: 'pointer', fontSize: 12, padding: '6px 12px', fontWeight: 700, marginLeft: 8, whiteSpace: 'nowrap' }}>
              📋 Kopyala
            </button>
          </div>
        </div>
        <div style={{ background: 'rgba(224,123,0,0.1)', border: '1px solid rgba(224,123,0,0.3)', borderRadius: 10, padding: 14, marginBottom: 16 }}>
          <p style={{ color: '#E07B00', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>📌 Önemli</p>
          <p style={{ color: '#aaa', fontSize: 13, lineHeight: 1.6 }}>
            Havale açıklamasına <strong style={{ color: '#fff' }}>#{siparisNo}</strong> sipariş numaranızı yazmayı unutmayınız.
          </p>
        </div>
        <p style={{ color: '#888', fontSize: 12, textAlign: 'center', lineHeight: 1.6 }}>
          Ödemenizi gerçekleştirdikten sonra dekontunuzu WhatsApp üzerinden temsilcinize iletmenizi rica ederiz. 🙏
        </p>
      </div>
    </div>
  );

  return (
    <div style={sayfaStyle}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 28, fontWeight: 800, color: '#E07B00', letterSpacing: -1 }}>{siparis.firma_ad || 'Ödeme'}</div>
        <div style={{ color: '#888', fontSize: 14, marginTop: 4 }}>Sipariş Bilgi Formu</div>
      </div>
      <div style={kartStyle}>
        <div style={{ marginBottom: 24, padding: 16, background: '#1a1d27', borderRadius: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <span style={{ color: '#888', fontSize: 13 }}>Sipariş No</span>
            <span style={{ color: '#fff', fontWeight: 700, fontFamily: 'monospace' }}>#{siparisNo}</span>
          </div>
          {kalemler.length > 0 && (
            <div style={{ borderTop: '1px solid #2a2d3a', paddingTop: 10, marginTop: 8 }}>
              {kalemler.map(k => (
                <div key={k.id} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6, fontSize: 13 }}>
                  <span style={{ color: '#bbb' }}>{k.urun_ad} <span style={{ color: '#666' }}>×{k.miktar}</span></span>
                  <span style={{ color: '#fff' }}>{(k.toplam || 0).toLocaleString('tr-TR')} ₺</span>
                </div>
              ))}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #2a2d3a', paddingTop: 10, marginTop: 8 }}>
            <span style={{ color: '#888', fontSize: 14 }}>Ödenecek Tutar</span>
            <span style={{ color: '#E07B00', fontWeight: 800, fontSize: 20 }}>{(siparis.toplam_tutar || 0).toLocaleString('tr-TR')} ₺</span>
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
            Ödeme Türü: {siparis.odeme_turu === 'banka' ? 'Banka Havalesi' : siparis.odeme_turu === 'kredi_karti' ? 'Kredi Kartı' : 'Elden/Nakit'}
          </div>
        </div>

        <h3 style={{ color: '#fff', fontSize: 15, fontWeight: 700, marginBottom: 16 }}>Bilgilerinizi Onaylayın</h3>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Ad Soyad *</label>
          <input style={inputStyle} value={form.ad_soyad} onChange={e => setForm(f => ({ ...f, ad_soyad: e.target.value }))} placeholder="Adınız ve Soyadınız" />
        </div>
        <div style={{ marginBottom: 14 }}>
          <label style={labelStyle}>Telefon</label>
          <input style={inputStyle} value={form.telefon} onChange={e => setForm(f => ({ ...f, telefon: e.target.value }))} placeholder="05XX XXX XX XX" type="tel" />
        </div>
        <div style={{ marginBottom: 20 }}>
          <label style={labelStyle}>Teslimat Adresi</label>
          <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical' }} value={form.adres} onChange={e => setForm(f => ({ ...f, adres: e.target.value }))} placeholder="Adresinizi yazınız..." />
        </div>
        <div style={{ background: 'rgba(224,123,0,0.1)', border: '1px solid rgba(224,123,0,0.3)', borderRadius: 10, padding: 14, marginBottom: 20 }}>
          <p style={{ color: '#E07B00', fontSize: 13, fontWeight: 600, marginBottom: 6 }}>📌 Ödeme Talimatı</p>
          <p style={{ color: '#aaa', fontSize: 13, lineHeight: 1.6 }}>
            Formu gönderdikten sonra ödemenizi gerçekleştirmenizi ve dekontunuzu WhatsApp üzerinden temsilcinize iletmenizi rica ederiz. 🙏
          </p>
        </div>
        {hata && (
          <div style={{ background: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)', borderRadius: 8, padding: '10px 14px', color: '#f87171', fontSize: 13, marginBottom: 16 }}>
            ⚠️ {hata}
          </div>
        )}
        <button
          style={{ width: '100%', padding: '14px', borderRadius: 10, border: 'none', background: yukleniyor ? '#555' : '#E07B00', color: '#fff', fontWeight: 700, fontSize: 16, cursor: yukleniyor ? 'not-allowed' : 'pointer' }}
          onClick={handleGonder} disabled={yukleniyor}>
          {yukleniyor ? '⏳ Gönderiliyor...' : '✓ Bilgileri Onayla'}
        </button>
        <p style={{ textAlign: 'center', color: '#555', fontSize: 11, marginTop: 16 }}>🔒 Bilgileriniz güvende.</p>
      </div>
    </div>
  );
}

const sayfaStyle = { minHeight: '100vh', background: '#0f1117', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', padding: '32px 16px 60px' };
const kartStyle = { width: '100%', maxWidth: 480, background: '#161921', borderRadius: 16, padding: 24, border: '1px solid #2a2d3a' };
const labelStyle = { display: 'block', color: '#aaa', fontSize: 12, marginBottom: 6, fontWeight: 600 };
const inputStyle = { width: '100%', background: '#1a1d27', border: '1px solid #2a2d3a', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box' };
